import { Observable } from "rxjs";
import { Company } from "../../models/company";
import { CosmosCustomer } from "../../models/customer";
import { CustomerSummary } from "../../models/customer-summary";

export abstract class ICustomerService {
    public abstract getCustomerByCode(axCode: string): Observable<CosmosCustomer>;
    public abstract getCustomersByCodes(axCodes: string[]): Observable<CustomerSummary[]>;
    public abstract getCompanyByCustomerRegisterCode(companyRegisterCode: string): Observable<Company>;
    public abstract isAgentSalesCustomer(axCode: string): Observable<boolean>;
}
